// 外部リンクの一括管理
export const externalLinks = {
  twitter: {
    url: "https://twitter.com/vr_launch",
    label: "Twitter",
  },
  calendar: {
    url: "https://calendar.google.com/calendar/u/0/embed?src=inoopdemi6k2uss2lktrfl0iu8@group.calendar.google.com",
    label: "Googleカレンダー",
    shortLabel: "カレンダー",
  },
  discord: {
    url: "https://discord.com/invite/SBeSSY4xC9",
    label: "Discord",
  },
  misskey: {
    url: "https://misskey.virtualrocketwatching.net/",
    label: "Misskey",
  },
  vrchat: {
    url: "https://vrchat.com/home/group/grp_3c6fc948-99c0-4f16-8a63-602aaab97554",
    label: "VRChat",
  },
} as const;

// 内部リンクの管理
export const internalLinks = {
  home: "/",
  about: "/about",
  mission: "/mission",
  meetup: "/meetup",
  images: "/images",
  participantForm: "/form/perticipant",
  staffForm: "/form/staff",
} as const;